export default class Kyc {
    constructor(
        logoPreview,
        logo,
        personName,
        email,
        phone,
        dob,
        gender,
        role,
        companyName,
        companyRegistrationNumber,
        businessAddress,
        bankersName,
        bankersAddress,
        businessReferencesName,
        businessReferencesAddress,
        acceptVat,
        idDocumentPreview,
        idDocument,
        registrationCertificatePreview,
        registrationCertificate,
        vatRegistrationCertificate,
        images,
    ) {
        this.logoPreview = logoPreview;
        this.logo = logo;
        this.personName = personName;
        this.email = email;
        this.phone = phone;
        this.dob = dob;
        this.gender = gender;
        this.role = role;
        this.companyName = companyName;
        this.companyRegistrationNumber = companyRegistrationNumber;
        this.businessAddress = businessAddress;
        this.bankersName = bankersName;
        this.bankersAddress = bankersAddress;
        this.businessReferencesName = businessReferencesName;
        this.businessReferencesAddress = businessReferencesAddress;
        this.acceptVat = acceptVat;
        this.idDocumentPreview = idDocumentPreview;
        this.idDocument = idDocument;
        this.registrationCertificatePreview = registrationCertificatePreview;
        this.registrationCertificate = registrationCertificate;
        this.vatRegistrationCertificate = vatRegistrationCertificate;
        this.images = images;
    }
}
